import axios from 'axios'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { $emit } from '../includes/event-bus'

interface Challenge {
	id: string
	type: string
	[key: string]: any
}

export const useChallenges = defineStore('challenges', () => {
	const list = ref<any[]>([])
	const idsList = ref<string[]>([])

	function setChallenges(value: []): void
	{
		list.value = value

		if(list.value?.length){ // Adjust the ids
			idsList.value = []
			value.forEach((item: any) => {
				idsList.value.push(item.id)
			})
		}else{ // It may happen we set a list to an initial state, reset ids list as well
			idsList.value = []
		}
	}

	function setPropertyById(id: string, key: string, value: any): void
	{
		// Find if the list of challenges contains the challenge with the provided id
		const idPos = getPositionById(id);
		if(idPos === null) return;

		// Set the key
		list.value[idPos][key] = value
	}

	function setPropertyForAll(key: string, value: any): void
	{
		// Set the key to all items in the list
		for(const i in list.value){
			list.value[i][key] = value
		}
	}

	function removeChallengeByType(type: string): void
	{
		if(!list.value || !list.value.length) return;

		// Keep only items that do NOT match the provided type
		const newList = list.value.filter(item => item.type !== type)

		if(newList.length){
			list.value = newList
			idsList.value = newList.map(item => item.id)
		}else{ // no items left, reset to initial state
			list.value = []
			idsList.value = []
		}
	}

	function removeChallengeById(id: string)
	{
		// Find if the list of challenges contains the challenge with the provided id
		const idPos = getPositionById(id);
		if(idPos === null) return;

		// Remove the id from the list of ids
		idsList.value.splice(idPos, 1)

		// Find position and delete the challenge from the list
		var itemPos = 0
		for (var i = 0; i < list.value.length; i++) {
			if(list.value[i].id == id) {
				itemPos = i
				break
			}
		}

		list.value.splice(itemPos, 1)
	}

	function addChallengeItem(value: Challenge): void
	{
		value.showBlock = 'default' // Set default value for every new challenge

		list.value.push(value)
		idsList.value.push(value.id)
	}

	function resetChallenges(): void
	{
		list.value = []
		idsList.value = []
	}

	async function snoozeChallenge(id: string)
	{
		// Remove challenge from the store optimistically
		removeChallengeById(id)

		// Send the request to the server
		await axios.post('/api/user-side/snoozeUserChallenge', { challenge_id: id })

		// Emit challenge snoozed event
		$emit('challenge-snoozed')
	}

	/**
	 * Get position of the challenge in the list by provided id
	 * @param id 
	 * @returns `null` if not found or `number` of the position
	 */
	function getPositionById(id: string): number | null
	{
		// Find if the list of challenges contains the challenge with the provided id
		if(idsList.value == null) return null;

		const idPos = idsList.value?.indexOf(id)
		if(idPos == -1) return null;

		return idPos
	}

	return {
		list,
		idsList,
		addChallengeItem,
		removeChallengeById,
		removeChallengeByType,
		setChallenges,
		resetChallenges,
		snoozeChallenge,
		setPropertyById,
		setPropertyForAll
	}
})